module.exports = "/_next/static/images/Pace-Team-297cca3ccac9cc37e5e8381802d50f94.jpg";